(function () {
  const MOBILE_MAX = 989;

  function isMobile() {
    return window.matchMedia(`(max-width:${MOBILE_MAX}px)`).matches;
  }

  function getSlides(slider) {
    return Array.from(slider.querySelectorAll('[id^="Slide-"]')).filter(el => el.offsetParent !== null);
  }

  function getActiveIndex(slider, slides) {
    const offset = slides[0]?.offsetLeft || 0;
    const itemOffset = (slides[1]?.offsetLeft ?? (offset + 1)) - offset;
    if (!itemOffset) return 0;
    return Math.max(0, Math.min(slides.length - 1, Math.round(slider.scrollLeft / itemOffset)));
  }

  function scrollToIndex(slider, slides, idx) {
    const left = slides[idx].offsetLeft;
    slider.scrollTo({ left, behavior: 'smooth' });
  }

  function buildDots(component) {
    if (!isMobile()) return;

    const slider = component.querySelector('[id^="Slider-"]');
    if (!slider) return;

    const slides = getSlides(slider);
    if (slides.length < 2) return;

    // wenn schon vorhanden, nicht doppelt bauen
    if (component.querySelector('.lua-dots')) return;

    const dots = document.createElement('div');
    dots.className = 'lua-dots';

    slides.forEach((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'lua-dot';
      b.setAttribute('aria-label', `Slide ${i + 1}`);
      b.addEventListener('click', () => scrollToIndex(slider, slides, i));
      dots.appendChild(b);
    });

    // Dots unter den Slider setzen (unterhalb der slider-buttons, falls vorhanden)
    const buttonsRow = component.querySelector('.slider-buttons');
    if (buttonsRow && buttonsRow.parentNode) {
      buttonsRow.parentNode.insertBefore(dots, buttonsRow.nextSibling);
    } else {
      component.appendChild(dots);
    }

    const update = () => {
      const idx = getActiveIndex(slider, slides);
      dots.querySelectorAll('.lua-dot').forEach((d, i) => {
        d.classList.toggle('is-active', i === idx);
      });
    };

    slider.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    component.addEventListener('slideChanged', update);
    window.addEventListener('resize', () => {
      // wenn auf Desktop gewechselt: Dots entfernen
      if (!isMobile()) dots.remove();
    });

    update();
  }

  function init() {
    if (!isMobile()) return;
    document.querySelectorAll('slider-component, slideshow-component').forEach(buildDots);
  }

  document.addEventListener('DOMContentLoaded', init);

  // falls Shopify Sections neu rendert (Theme Editor / AJAX)
  document.addEventListener('shopify:section:load', init);
})();
